import { render, staticRenderFns } from "./mod-user-status.vue?vue&type=template&id=274cccc8&"
import script from "./mod-user-status.vue?vue&type=script&lang=js&"
export * from "./mod-user-status.vue?vue&type=script&lang=js&"
import style0 from "./mod-user-status.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports